import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { formatRupiah } from "@/lib/constants";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import UploadSPKDialog from "@/components/UploadSPKDialog";
import { CloudUpload, Search, ChevronRight } from "lucide-react";

// Upload SPK Fix: user must pick the correct waiting claim first, then upload on the claim page.
export default function SpkClaimPicker({ onCreated, allowNew = true, className = "" }) {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  useEffect(() => { if (open) { setRows(null); api.get("/waiting-spk").then((r) => setRows(r.data || [])).catch(() => setRows([])); } }, [open]);
  const list = (rows || []).filter((r) => !q || `${r.license_plate} ${r.customer_name} ${r.insurance_company}`.toUpperCase().includes(q.toUpperCase()));
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="spk-picker-btn" className={`ti-btn-blue inline-flex h-11 items-center gap-2 rounded-lg px-4 ${className}`}><CloudUpload size={18} />Upload SPK</button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl font-bold">Upload SPK Fix — Pilih Claim</DialogTitle>
          <DialogDescription className="text-[15px] text-[#475569]">Pilih claim asuransi yang menunggu SPK Fix. SPK diunggah, dibaca OCR, dan diverifikasi di halaman claim tersebut.</DialogDescription>
        </DialogHeader>
        <div className="relative"><Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#475569]" /><Input data-testid="spk-picker-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari nopol / konsumen / asuransi" className="h-11 pl-9" /></div>
        <div className="space-y-2">
          {rows === null && <p className="py-6 text-center text-[#475569]">Memuat…</p>}
          {list.map((r) => (
            <button key={r.id} data-testid={`spk-picker-row-${r.id}`} onClick={() => { setOpen(false); navigate(`/claims/${r.id}`); }} className="flex w-full items-center gap-3 rounded-xl border border-[#E2E5EA] bg-white p-3 text-left transition-colors hover:border-[#20466D] hover:bg-[#F4F5F7]">
              <span className="ti-plate">{r.license_plate}</span>
              <span className="min-w-0 flex-1">
                <span className="block truncate font-semibold text-[#111827]">{r.customer_name || "-"} · {r.vehicle_brand || ""}</span>
                <span className="block truncate text-[13px] text-[#475569]">{r.insurance_company} · {r.estimate_total ? `Estimasi ${formatRupiah(r.estimate_total)}` : "tanpa estimasi"} · {r.aging_days} hari</span>
              </span>
              <ChevronRight size={18} className="text-[#20466D]" />
            </button>
          ))}
          {rows && list.length === 0 && <p data-testid="spk-picker-empty" className="py-6 text-center text-[#475569]">Tidak ada claim menunggu SPK Fix. Buat dulu melalui Estimasi → LANJUTKAN.</p>}
        </div>
        {allowNew && (
          <div className="flex flex-wrap items-center justify-between gap-2 border-t border-[#E2E5EA] pt-3 text-[13px] text-[#475569]">
            <span>SPK untuk kendaraan yang belum terdaftar?</span>
            <UploadSPKDialog compact onCreated={(c) => { setOpen(false); onCreated && onCreated(c); }} />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
